Vue.asyncComponent('cms-dashboard-debug-status', {
    props: {
        statusLabel: {
            type: String,
            default: '',
        },
        statusValue: {
            type: String,
            default: '',
        },
        statusDescription: {
            type: String,
            default: '',
        },
        isEnabled: {
            type: Boolean,
            default: false,
        },
    },
}, 'cms/dashboard/live/cms-dashboard-debug-status.html');
